var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_1272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.175 1.94512C17.501 2.26099 16.7861 2.46833 16.054 2.56024C16.8165 2.07677 17.402 1.31117 17.6777 0.398975C16.9528 0.854022 16.1598 1.17463 15.3327 1.34695C14.6591 0.587752 13.6994 0.113281 12.6372 0.113281C10.5977 0.113281 8.94414 1.86241 8.94414 4.01973C8.94414 4.32595 8.97684 4.62407 9.03977 4.91006C5.97063 4.74709 3.24953 3.19188 1.42809 0.828372C1.11028 1.40534 0.928166 2.07647 0.928166 2.79231C0.928166 4.14766 1.58017 5.34332 2.57102 6.04391C1.98458 6.02448 1.41104 5.85693 0.898283 5.55523C0.898072 5.5716 0.898072 5.58796 0.898072 5.6044C0.898072 7.49715 2.17101 9.07609 3.86034 9.43498C3.31653 9.59143 2.74612 9.61432 2.19267 9.50192C2.66256 11.0539 4.02642 12.1833 5.64234 12.2149C4.37847 13.2627 2.7861 13.8872 1.05599 13.8872C0.757869 13.8872 0.463963 13.8687 0.175049 13.8326C1.80932 14.941 3.75044 15.5878 5.83591 15.5878C12.6286 15.5878 16.343 9.63506 16.343 4.47278C16.343 4.30334 16.3395 4.13487 16.3323 3.96736C17.0553 3.41448 17.6793 2.72969 18.175 1.94512Z",
    fill: "#55ACEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_1272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15.5455,
    fill: "white",
    transform: "translate(0.175049 0.0517578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.502341b8e9e07eb49b900b0a0dc982d6.svg";
export { ForwardRef as ReactComponent };